import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@/app/App';
import { authStore } from '@/auth/authStore';
import { flushPendingResults } from '@/save/progress';
import '@/styles/meta.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element missing');

// тихий refresh → /me (гость, если сессии нет), затем дошлём результаты
// из dg_pending_v1, не доехавшие в прошлой сессии
void authStore.bootstrap().then(() => flushPendingResults());

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
